const SUPPORTED_LANGUAGES = ['it', 'en'];
const ITALIAN_TIMEZONES = ['europe/rome', 'europe/vatican', 'europe/san_marino'];

const normalizeLanguage = (value) => {
  if (!value || typeof value !== 'string') {
    return null;
  }
  const lower = value.toLowerCase();
  const base = lower.split('-')[0];
  return SUPPORTED_LANGUAGES.includes(base) ? base : null;
};

export const detectEnvironmentLanguage = () => {
  if (typeof window === 'undefined') {
    return 'it';
  }

  const navigatorLanguages = [];
  try {
    if (Array.isArray(window.navigator?.languages)) {
      navigatorLanguages.push(...window.navigator.languages);
    }
    if (window.navigator?.language) {
      navigatorLanguages.push(window.navigator.language);
    }
  } catch (error) {
    console.warn('[Locale] Unable to read navigator languages', error);
  }

  for (const candidate of navigatorLanguages) {
    const normalized = normalizeLanguage(candidate);
    if (normalized === 'it') {
      return 'it';
    }
  }

  try {
    const options = Intl.DateTimeFormat().resolvedOptions?.() || {};
    const locale = normalizeLanguage(options.locale);
    if (locale === 'it') {
      return 'it';
    }

    const timeZone = options.timeZone?.toLowerCase();
    if (timeZone && ITALIAN_TIMEZONES.includes(timeZone)) {
      return 'it';
    }
  } catch (error) {
    console.warn('[Locale] Unable to resolve Intl locale/timezone', error);
  }

  return 'en';
};

export const loadStoredLanguage = (storageKey) => {
  if (typeof storageKey !== 'string' || !storageKey) {
    return null;
  }
  if (typeof localStorage === 'undefined') {
    return null;
  }
  try {
    const stored = localStorage.getItem(storageKey);
    const normalized = normalizeLanguage(stored);
    if (normalized) {
      return normalized;
    }
  } catch (error) {
    console.warn('[Locale] Unable to read stored language', error);
  }
  return null;
};

export const getLocationBasedLanguage = (storageKey) => {
  const stored = storageKey ? loadStoredLanguage(storageKey) : null;
  if (stored) {
    return stored;
  }
  return detectEnvironmentLanguage();
};

export const isSupportedLanguage = (language) => normalizeLanguage(language) !== null;
